<template>
  <div class="look-goods">
    <div class="info-steps">
      <!--        auditWhether 反馈状态（0 待反馈 1 已反馈）-->
      <el-steps
        v-if="applyInspectForm.servePreNoticeSimpleVO.enrollExamine == 1"
        :active="applyInspectForm.auditWhether === 0 ? 2 : 3"
        align-center
      >
        <el-step title="提交报名"></el-step>
        <el-step title="资格审核"></el-step>
        <el-step title="预约反馈"></el-step>
      </el-steps>
      <el-steps
        v-else
        :active="applyInspectForm.auditWhether === 0 ? 1 : 2"
        align-center
      >
        <el-step title="提交报名"></el-step>

        <el-step title="预约反馈"></el-step>
      </el-steps>
    </div>
    <el-divider></el-divider>

    <div class="look-goods-info">
      <el-form
        ref="ruleForm"
        label-position="right"
        label-width="200px"
        :model="lookGoodsForm"
        label-suffix=":"
      >
        <div style="padding-left: 30px;font-weight: 700;font-size:18px">
          看货信息
        </div>
        <el-divider></el-divider>
        <el-row>
          <el-col :span="12"
            ><el-form-item label="看货开始时间">{{
              applyInspectForm.servePreNoticeSimpleVO.inspectStartTime
            }}</el-form-item></el-col
          >
          <el-col :span="12">
            <el-form-item label="距截止看货"
              ><count-down
                :type="1"
                :startTime="applyInspectForm.systemDate"
                :endTime="
                  applyInspectForm.servePreNoticeSimpleVO.inspectEndTime
                "
              ></count-down
            ></el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="看货截止时间">{{
          applyInspectForm.servePreNoticeSimpleVO.inspectEndTime
        }}</el-form-item>
        <el-form-item label="看货地点"
          ><span
            >{{ applyInspectForm.servePreNoticeSimpleVO.proviceName
            }}{{ applyInspectForm.servePreNoticeSimpleVO.cityName
            }}{{ applyInspectForm.servePreNoticeSimpleVO.countyName
            }}{{ applyInspectForm.servePreNoticeSimpleVO.inspectAddress }}</span
          ></el-form-item
        >
        <el-form-item label="看货说明"
          ><span>{{
            applyInspectForm.servePreNoticeSimpleVO.inspectReamrk
          }}</span></el-form-item
        >
        <div>
          <div class="divider">
            现场看货
          </div>
          <el-divider></el-divider>
          <!-- 预约看货 -->
          <div>
            <el-col :span="12">
              <el-col :span="20">
                <el-form-item label="反馈看货时间" prop="inspectApplyTime">{{
                  applyInspectForm.inspectApplyTime
                }}</el-form-item>
              </el-col>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最多看货人数" prop="inspectApplyNum">{{
                applyInspectForm.inspectApplyNum
              }}</el-form-item>
            </el-col>
            <el-form-item label="预约说明">
              <span>{{ applyInspectForm.inspectApplyRemark }}</span>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="联系人" prop="contName">
                  <span>{{ applyInspectForm.inspectApplyContName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机" prop="contMobile">
                  <span>{{ applyInspectForm.inspectApplyContMobile }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="邮箱" prop="contEmail">
                  <span>{{ applyInspectForm.inspectApplyContEmail }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话" prop="contPhone">
                  <span>{{ applyInspectForm.inspectApplyContPhone }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-form-item label="传真" prop="contFax">
                  <span>{{ applyInspectForm.inspectApplyContFax }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="其他联系方式" prop="contOtherWay">
                  <span>{{ applyInspectForm.inspectApplyConOtherWay }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <div class="divider">
            看货反馈
          </div>
          <el-divider></el-divider>
          <!-- 已反馈 -->
          <div v-if="applyInspectForm.auditWhether">
            <el-row>
              <el-col :span="12">
                <el-col :span="20">
                  <el-form-item label="反馈看货时间" prop="inspectApplyTime">{{
                    applyInspectForm.inspectFeedbackTime
                  }}</el-form-item>
                </el-col>
              </el-col>
              <el-col :span="12">
                <el-form-item label="最多看货人数" prop="inspectApplyNum"
                  ><span>{{
                    applyInspectForm.inspectFeedbackNum
                  }}</span></el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="看货地点" prop="inspectFeedbackRemark"
                  ><span>{{
                    applyInspectForm.inspectFeedbackPlace
                  }}</span></el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="反馈说明" prop="inspectFeedbackRemark"
                  ><span>{{
                    applyInspectForm.inspectFeedbackRemark
                  }}</span></el-form-item
                >
              </el-col>
            </el-row>
            <el-row>
              <el-form-item label="附件" prop="">
                <a
                  class="file-a"
                  v-for="item in applyInspectForm.fileList"
                  :href="baseUrl + item.fileWebpath"
                  :key="item.fileId"
                  >{{ item.fileName }}</a
                >
              </el-form-item>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-col :span="20">
                  <el-form-item label="联系人" prop="inspectApplyTime"
                    ><span>{{
                      applyInspectForm.inspectFeedbackContName
                    }}</span></el-form-item
                  >
                </el-col>
              </el-col>
              <el-col :span="12">
                <el-form-item label="联系电话" prop="inspectApplyNum"
                  ><span>{{
                    applyInspectForm.inspectFeedbackContMobile
                  }}</span></el-form-item
                >
              </el-col>
            </el-row>
          </div>
          <div v-else style="padding-left:160px">待反馈...</div>
        </div>
      </el-form>
    </div>
    <div class="page-index-footer">
      <el-button type="plain" @click="onResetForm('applyInspect')"
        >关闭</el-button
      >
    </div>
  </div>
</template>

<script>
import config from '@/config'
// import inspect from "../../api/modules/inspect";
export default {
  name: 'LookTheGoods',
  components: {},
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      mateFiles: [],
      surveyVo: {},
      baseUrl: config.STATIC_URL,
      inspectId: this.$route.query.inspectId,
      noticeId: this.$route.query.noticeId,
      lookInfo: {},
      lookGoodsForm: {
        title: '',
        compName: '',
        inspectAddress: '',
        inspectStartTime: Date.now(),
        inspectEndTime: Date.now(),
        systemDate: Date.now(),
        inspectReamrk: ''
      },
      // auditWhether 反馈状态（0 待反馈 1 已反馈）
      // auditWhetherView	 审批状态（前台展示）
      //申请看货form
      applyInspectForm: {
        servePreNoticeSimpleVO: {}
      },
      pickerOptions: {
        disabledDate() {
          return false
        }
      },
      surveyFilesVO: [],
      //反馈看货信息
      feedbackInfoForm: {
        inspectFeedbackContEmail: '',
        inspectFeedbackContMobile: '',
        inspectFeedbackContFax: '',
        inspectFeedbackContName: '',
        inspectFeedbackContPhone: '',
        inspectFeedbackNum: '',
        inspectFeedbackPlace: '',
        inspectFeedbackRemark: '',
        inspectFeedbackTime: '',
        inspectFileList: ''
      }
    }
  },
  computed: {},
  watch: {},
  created() {
    this.noticeId = this.$route.query.noticeId

    this.getBuyerPreInspect()
  },
  methods: {
    async getBuyerPreInspect() {
      let data = await this.$api.serviceProvider.getBuyerPreInspect({
        noticeId: this.noticeId
      })
      this.applyInspectForm = {
        ...data,
        ...data.servePreInspectInfoVO
      }
      console.log(this.applyInspectForm)
    },
    //申请看货信息
    async getGoodsInfo(params) {
      let data = await this.$api.inspect.getInspectInfo(params)
      this.lookGoodsForm = JSON.parse(JSON.stringify(data))
      this.applyInspectForm = JSON.parse(JSON.stringify(data))
    },
    //踏勘信息
    async getBuyerSurvey() {
      let params = {
        noticeId: this.noticeId
      }
      let data = await this.$api.inspect.getBuyerSurvey(params)
      console.log(data)
      this.surveyVo = data
    },

    //看货反馈信息
    async getInpectInfo(params) {
      this.feedbackInfoForm = await this.$api.inspect.getInspectDetail(params)
      this.lookGoodsForm = {
        ...this.feedbackInfoForm.noticeVO,
        ...this.feedbackInfoForm
      }
      // this.lookGoodsForm.inspectFileList = this.feedbackInfoForm.inspectFileList;
    },
    onResetForm() {
      this.$router.go(-1)
    },
    //下载附件
    downloadFile(href) {
      window.location.href = `${this.baseUrl}/${href}`
    },
    async onDownload(item) {
      let res = await this.$api.common.downloadFile(item.fileId)
      let blob = new Blob([res])
      let fileName = item.fileName
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName)
      } else {
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        link.remove()
        URL.revokeObjectURL(link.href)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.look-goods {
  padding: 40px 0px;
  .file-a {
    color: #427bd4;
    cursor: pointer;
    display: block;
  }
  .el-breadcrumb {
    padding-left: 11px;
    line-height: 40px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .look-goods-info,
  .look-goods-apply {
    padding: 24px 31px;
    .section-card {
      border-top: 1px solid #dadada;
      .section-card-title {
        background: #fff;
      }
      .section-card-body {
        .inspect-require,
        .inspect-file {
          width: 100%;
          .el-form-item__content {
            width: 86%;
            a {
              display: block;
              color: #427bd4;
              cursor: pointer;
            }
          }
        }
        .el-form-item__content {
          .el-textarea {
            width: 790px;
          }
          .el-date-editor {
            width: 87%;
          }
        }
      }
    }
  }
  .feedback-info {
    .section-card {
      border-top: 1px solid #dadada;
      .section-card-title {
        background: #fff;
      }
    }
    .feed-back {
      .el-form-item__content {
        width: 86%;
      }
    }
  }
  .input-number {
    .el-input-number .el-input__inner {
      text-align: left;
    }
  }
}
.special {
  color: red;
  font-weight: bold;
}
::v-deep .button {
  .el-button {
    padding: 5px 10px;
  }
}
.divider {
  padding-left: 30px;
  font-weight: 700;
  font-size: 18px;
  padding-top: 20px;
}
</style>
